<template>
  <div class="main-container">
    <Navbar></Navbar>
    <head-bar></head-bar>
    <div>
      <app-main></app-main>
    </div>
    <ServiceBtn v-if="currentRoute != '/register/index'"></ServiceBtn>
  </div>
</template>

<script>
import Navbar from "@/layout/components/Navbar.vue";
import HeadBar from "@/layout/components/HeadBar.vue";
import AppMain from "@/layout/components/AppMain.vue";
import ServiceBtn from "@/layout/components/ServiceBtn.vue";
export default {
  name: 'LayoutIndex',
  components: {
    ServiceBtn,
    Navbar,
    HeadBar,
    AppMain
  },
  computed: {
    currentRoute() {
      console.log('currentRoute-path', this.$route.path)
      return this.$route.path
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.main-container{
  width: 900px;
  margin: 0 auto;
}
</style>
